const browserSlice = (set) => ({
  browserTimezoneName: null,
  setBrowserTimezoneName: (browserTimezoneName) =>
    set(() => ({
      browserTimezoneName,
    })),
})

export default browserSlice
